import profile from './profile'
import auth from './auth'
import setting from './setting'
import branding from './branding'

const reducers = { auth, profile, setting, branding }
export default reducers
